import React, { useEffect, useState, useCallback } from 'react';
import './ScrollToBottomButton.css';

const ScrollToBottomButton = () => {
  const [visible, setVisible] = useState(false);

  const checkVisibility = useCallback(() => {
    const scrollY = window.scrollY || window.pageYOffset;
    const viewportH = window.innerHeight;
    const docH = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight
    );

    const canScroll = docH > viewportH + 40; // 余白
    const nearBottom = scrollY + viewportH >= docH - 120; // 下端から120px以内

    setVisible(canScroll && !nearBottom);
  }, []);

  useEffect(() => {
    checkVisibility();
    window.addEventListener('scroll', checkVisibility, { passive: true });
    window.addEventListener('resize', checkVisibility);
    return () => {
      window.removeEventListener('scroll', checkVisibility);
      window.removeEventListener('resize', checkVisibility);
    };
  }, [checkVisibility]);

  const handleClick = () => {
    // 高速スクロール（約200msで到達）
    const startY = window.scrollY || window.pageYOffset;
    const viewportH = window.innerHeight;
    const docH = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight
    );
    const targetY = Math.max(0, docH - viewportH);
    const distance = targetY - startY;
    const duration = 200; // ミリ秒（速め）

    if (distance <= 0) return; // すでに最下部

    const startTime = performance.now();
    const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

    const step = (now) => {
      const elapsed = now - startTime;
      const t = Math.min(1, elapsed / duration);
      const eased = easeOutCubic(t);
      window.scrollTo(0, startY + distance * eased);
      if (t < 1) requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  };

  return (
    <button
      type="button"
      className={`scroll-to-bottom-btn ${visible ? '' : 'is-hidden'}`}
      onClick={handleClick}
      aria-label="一番下へ移動"
      title="一番下へ"
    >
      <span className="scroll-to-bottom-btn__icon" aria-hidden>▼</span>
    </button>
  );
};

export default ScrollToBottomButton;
